// removed by extract-text-webpack-plugin
module.exports = {"sdgLegend":"sdgLegend__2PgM0","rightSDG":"rightSDG__3_9kW","sdgImage":"sdgImage__2Ay3q","leftSDG":"leftSDG__26aKL","sdgItem":"sdgItem__2Cf3H","sdgPercent":"sdgPercent__1t9Cd","imageItem":"imageItem__3mvY5","othersItem":"othersItem__1jHa_","sdgName":"sdgName__xImdG","sdgTooltip":"sdgTooltip__1qWI5"};


//////////////////
// WEBPACK FOOTER
// ./components/sunburstChart/components/sdgLegend/style.scss
// module id = /lS5
// module chunks = 0